import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SisLoader from "../../../../../widgets/loader";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import {  IGGCargoMachinCom } from "../../components/CargoMachinCom/IGGCargoMachin";

export const IGGCargoMachinListCom = (ship_id) => {
  const { eng_log_basic_id } = useParams();
  const [loader, set_loader] = useState(false);
  const [IGG_Data, set_IGG_Data] = useState([]);

  const GET_SHIP_IGG_LISTS = async (ship_id) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      FORM_DATA.append("ship_id", ship_id);
      post(ApiURL.list_cargo_igg_machinery_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_loader(false);
          set_IGG_Data(res?.response_data);
        }
      });

      set_loader(false);
    } catch (error) {
      set_loader(false);
      console.error("Error boiler list:", error);
    }
  };

  useEffect(() => {
    const ship_id = JSON.parse(localStorage.getItem("ship_id"));
    GET_SHIP_IGG_LISTS(ship_id);
  }, []);

  return (
    <>
      <div className="white-container">
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {IGG_Data ? (
              <>
                {IGG_Data?.map((_items) => (
                  <>
                    <IGGCargoMachinCom eng_log_basic_id={eng_log_basic_id} _items={_items} />
                  </>
                ))}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
};
